module.exports = __webpack_public_path__ + "static/media/new_folder.2240c212.svg";